<template>
  <div class="mx-8">
    <v-card
      flat
      :color="wc_color"
      class="rounded-lg pb-6"
      style="margin-left: auto; margin-right: auto"
      :width="widthCard"
    >
      <v-card-title v-if="image" class="justify-center px-4">
        <v-img
          v-if="image_size === '100%'"
          :src="image_url"
          width="100"
          height="auto"
        ></v-img>
        <img v-else :src="image_url" :width="TabletSize || mobile_mode ? '100%' : image_size+'%'" />
        <!-- <img v-else :src="image_url" width="100%" /> -->
      </v-card-title>
      <div v-if="!closed.swap_title">
        <v-card-title
          :class="`d-flex justify-${closed.text_justify}`"
          :style="`color: ${closed.close_text_color};`"
        >
          {{ closed.close_text }}
        </v-card-title>
        <v-card
          flat
          color="transparent"
          width="100%"
          class="d-flex justify-center align-center"
        >
          <v-card flat :color="wc_bg_title" width="100%" class="mx-4">
            <v-card-title
              :style="`color: ${wc_title}; font-size: 20px;word-break: break-word;`"
              :class="`justify-${wc_justify}`"
            >
              {{ surveyInfo.surveyName }}</v-card-title
            >
            <v-card-subtitle
              :style="`color: ${wc_subtitle};text-align: ${wc_justify};word-break: break-word;`"
              >{{ surveyInfo.surveyDetail }}
            </v-card-subtitle>
          </v-card>
        </v-card>
      </div>
      <div v-else>
        <v-card
          flat
          color="transparent"
          width="100%"
          class="d-flex justify-center align-center"
        >
          <v-card flat :color="wc_bg_title" width="100%" class="mx-4">
            <v-card-title
              :style="`color: ${wc_title}; font-size: 20px;word-break: break-word;`"
              :class="`justify-${wc_justify}`"
            >
              {{ surveyInfo.surveyName }}</v-card-title
            >
            <v-card-subtitle
              :style="`color: ${wc_subtitle};text-align: ${wc_justify};word-break: break-word;`"
              >{{ surveyInfo.surveyDetail }}
            </v-card-subtitle>
          </v-card>
        </v-card>
        <v-card-title
          :class="`d-flex justify-${closed.text_justify}`"
          :style="`color: ${closed.close_text_color};`"
        >
          {{ closed.close_text }}
        </v-card-title>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  props: [
    "surveyInfo",
    "image",
    "image_url",
    "image_size",
    "wc_color",
    "wc_bg_title",
    "wc_title",
    "wc_subtitle",
    "wc_justify",
    "closed",
    "wc_fullwidth",
    "mobile_mode",
  ],
  data() {
    return {
      WImg: "100%",
      HImg: "auto",
    };
  },
  computed: {
    TabletSize() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown;
    },
    // widthCard() {
    //   if (this.TabletSize || this.mobile_mode) {
    //     return "100%";
    //   } else {
    //     if (this.image) {
    //       if (this.image_size === "100%") {
    //         return "100%";
    //       } else {
    //         return this.image_size + "%";
    //       }
    //     } else {
    //       return "100%";
    //     }
    //   }
    // },
    widthCard() {
      if (this.TabletSize || this.mobile_mode) {
        return "100%";
      } else {
        return "100%";
      }
    },
  },
};
</script>
